<template>
  <form @submit.prevent>
    <sticky-header class="d-flex align-center justify-space-between px-0">
      <slot name="header" :on-submit="onSubmit">
        <v-row align="center" class="px-1 px-md-3">
          <v-col cols="12" sm="6">
            <div class="black--text text--darken-6 text-h2 text-md-h1 pt-2 pb-0 pt-sm-5 d-flex justify-start">
              {{ title }}
            </div>
            <slot name="description">
              <div v-if="description" class="form-block-subtitle">
                {{ description }}
              </div>
            </slot>
          </v-col>
          <v-col cols="12" sm="6" class="d-flex justify-start justify-sm-end flex-row flex-wrap flex-sm-nowrap">
            <slot name="leftActions" />
            <slot name="actions">
              <ui-button
                v-if="readonly && !hideActions"
                variant="secondary"
                class="mx-0 form-entity-btn"
                @click="$router.back()"
              >
                {{ $t('base.back') }}
              </ui-button>
              <ui-button
                v-if="!hideActions && !readonly"
                variant="secondary"
                :disabled="isLoading"
                class="ml-0 mr-3 mr-md-3 mx-md-3 mb-0 mb-md-0 form-entity-btn"
                @click="$emit('saveBack')"
              >
                {{ $t('base.saveBack') }}
              </ui-button>
              <ui-button
                v-if="checkPermission && !hideActions && !readonly"
                :disabled="isLoading"
                class="form-entity-btn blue500"
                @click="onSubmit"
                type="submit"
              >
                {{ $t('base.save') }}
              </ui-button>
            </slot>
          </v-col>
        </v-row>
      </slot>
    </sticky-header>
    <slot></slot>
  </form>
</template>

<script>
import StickyHeader from '@/components/ui/StickyHeader'
import { hasPermission } from '@/helpers/permission'
import {isEmpty} from "lodash";
import { provideFormReadonly } from '@/mixins/FormReadonlyMixin'

export default {
  name: 'ui-form-entity',
  components: { StickyHeader },
  provide() {
    return provideFormReadonly(() => this.readonly)
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    pathName: {
      type: String,
      default: '',
    },
    permission: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
    // CPA-3558: user can view the entity but not edit it — fields render as text, save buttons are hidden
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checkPermission() {
      return isEmpty(this.permission) ? true : this.hasPermission(this.permission)
    },
  },
  methods: {
    hasPermission,
    onSubmit() {
      this.$emit('onSubmit')
    },
  },
}
</script>

<style lang="scss">
  .form-entity-btn {
    width: 120px;
    @media #{map-get($display-breakpoints, 'xs-only')} {
      width: calc(50% - 6px)!important;
    }
  }
</style>
